export enum FaceVerificationSteps {
  INSTRUCTIONS = "INSTRUCTIONS",
  VERIFICATION = "VERIFICATION"
}

export enum AlertModalVariants {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE"
}